import { render } from "./CustomButton.vue?vue&type=template&id=14dd8ae0&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=14dd8ae0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14dd8ae0"

export default script